<script>
import ModalWrapperChoice from "@/components/modals/ModalWrapperChoice";

export default {
  name: "RespecIAPModal",
  components: {
    ModalWrapperChoice
  },
  methods: {
    returnedSTDCount() {
      let std = 0;
      for (const purchase of ShopPurchase.all) {
        if (purchase.config.instantPurchase) continue;
        std += purchase.purchases * purchase.cost;
      }
      return std;
    },
    handleYesClick() {
      ShopPurchaseData.respecAll();
      EventHub.ui.offAll(this);
    }
  },
};
</script>

<template>
  <ModalWrapperChoice
    option="respecIAP"
    @confirm="handleYesClick"
  >
    <template #header>
      Вы собираетесь сбросить ваши покупки в Магазине
    </template>
    <div class="c-modal-message__text">
      Вы уверены, что хотите сбросить покупки в Магазине? Это ничего не будет вам стоит и
      вернёт {{ returnedSTDCount() }}
      <img
        src="images/std_coin.png"
        class="o-shop-button-button__img"
      >, которые вы потратили на все покупки, дающие постоянные множители.
      <br>
      <br>
      Всё, потраченное на офлайн прогресс и косметику Глифов не будет возвращено. Косметические наборы Глифов
      необратимы и не будут потеряны или сброшены после покупки.
      <br>
      <br>
      <b class="o-warning">Вы не сможете сделать сброс вновь до тех пор, пока не купите больше ЗППП-коинов.</b>
    </div>
  </ModalWrapperChoice>
</template>

<style scoped>
.c-modal-message__text {
  vertical-align: middle;
}

.o-shop-button-button__img {
  height: 2.5rem;
  vertical-align: middle;
}

.o-warning {
  color: var(--color-infinity);
}
</style>
